import { conditionConstants } from "../constants/condition.constants";

export const conditionTranslator = {
  translateOperator
};

function translateOperator (operator){
  switch (operator) {
    case conditionConstants.operators.EQUAL:
      return "==";
    case conditionConstants.operators.NOT_EQUAL:
      return "!=";
    case conditionConstants.operators.GREATER_THAN:
      return ">";
    case conditionConstants.operators.LESS_THAN:
      return "<";
    case conditionConstants.operators.LESS_THAN_OR_EQUAL_TO:
      return "<=";
    case conditionConstants.operators.GREATER_THAN_OR_EQUAL_TO:
      return ">=";
    case conditionConstants.operators.AND:
    return "&&";
    case conditionConstants.operators.OR:
    return "||";
    default:
        return ""
  }
};
